const { Preprocessor } = require("./node/content_tag.cjs");

module.exports.Preprocessor = Preprocessor;
